<template>
  <div id="app">
    <div v-if="facility=='app'" :class="facility=='app'?'content':''" >
      <router-view></router-view>
      <Mfooter v-if="facility=='app'"/>
    </div>
    <div v-else>
      <Pnav/>
      <div class="height"></div>
      <router-view></router-view>
      <Pfooter/>
    </div>
  </div>
</template>

<script>
import Mfooter from "./components/app/footer";
import Pnav from "./components/pc/nav";
import Pfooter from "./components/pc/footer";
import { reqAutoLogin } from "./api";

export default {
  name: 'App',
  components: {
    Mfooter,
    Pnav,
    Pfooter
  },
  data () {
    return {
      facility:false  
    }
  },
  beforeMount(){
    this.facility = this.isMobile()
    this.autologin()
  },
  methods:{
    async autologin(){
      const response = await reqAutoLogin()
      if (response.code) {
        this.$store.dispatch("userInformation",response.resilt)
        this.$store.dispatch("isLogin",1)
      }else{
        localStorage.removeItem('islogin')
        localStorage.removeItem('user')
        this.$store.dispatch("userInformation",'')
        this.$store.dispatch("isLogin",0)
      }
    },
    async openWx(){//跳转到小程序
      location.href = 'weixin://dl/business/?t=lDX88LdX9Ai'
    },
    isWeiXin(){
      var ua = window.navigator.userAgent.toLowerCase();
        if(ua.match(/MicroMessenger/i) == 'micromessenger'){
            return true;
        }else{
            return false;
        }
    },
  }
}
</script>

<style>
  *{
    padding: 0;
    margin: 0;
  }
  .project_detail{/* 详情页层级关系 */
    position: relative;
    z-index: 1;
    background-color: #f4f4f4;
  }
  .appcode{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    width: 300px;
  }
  .appcode h2{
    margin-bottom: 30px;
  }
  .height{
    height: 61px;/*no*/
  }
  .weui-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  #app .el-input.is-active .el-input__inner,
  #app .el-input__inner:focus{
    border-color: #008baf;
  }
  .el-table th>.cell,
  .el-button{
    font-family: 'FjallaOne-Regular';
  }
  .el-popconfirm__action{
    margin-top: 10px;
  }
  @media (min-width: 768px) and (max-width: 869px) {
    .height{
      height: 111px;/*no*/
    }
  }
  #app{
    overflow: hidden;
    width: 100%;
  }
  .content{
    width: 100%;
    height: 100vh;
  }
  .app {
    padding: 0 10px;
    width: 100%;
    height: calc(100vh - 55px);
    overflow-y: auto;
    box-sizing: border-box;
    font-size: 12px;
  }
  img{
    width: 100%;
    height: 100%;
    object-fit: contain;
    outline: none;
  }

  .more_loading{
    text-align: center;
    padding-bottom: 10px;
    width: 100%;
    margin-top: 10px;
  }
  .m_upload{
    display: flex;
    justify-content: center;
  }
  .m_upload span{
    margin-right:5px ;
  }
  .detailsContent{
    height: calc(100% - 30px);
    overflow-y: auto;
    padding: 0 10px;
  }
</style>
